import React from "react"
import { v4 as uuidv4 } from "uuid"
import { FormError } from "models/form"

export type HiddenInputFileProps = {
	name: string
	disabled?: boolean
	readonly?: boolean
	required?: boolean
	inputId: string
	errorId?: string
	errors?: FormError[]
	ref: React.Ref<HTMLInputElement>
	onChange?: (...args: any) => void
	onFocus?: (...args: any) => void
	onBlur?: (...args: any) => void
}

export const HiddenInputFile: React.FC<HiddenInputFileProps> = React.forwardRef(
	(
		{
			name,
			inputId,
			errorId = uuidv4(),
			errors = [],
			disabled,
			readonly,
			required,
			// Handler
			onChange,
			onFocus,
		},
		ref: React.Ref<HTMLInputElement>
	) => (
		<input
			className="sr-only"
			type={"file"}
			name={name}
			id={inputId}
			ref={ref}
			disabled={disabled}
			readOnly={readonly}
			required={required}
			onChange={(e) => onChange && onChange(e)}
			onFocus={(e) => onFocus && onFocus(e)}
			onBlur={(e) => onFocus && onFocus(e)}
			aria-describedby={errorId}
			aria-invalid={Boolean(errors.length)}
		/>
	)
)
